import {
  AkaAdviceCheckboxes,
  AkaCriticalIllnessAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import { AKA_CRITICAL_ILLNESS_DEFAULT_G_VALUE } from "Components/Features/CheckPrice/Products/Advice/adviceConstants";
import {
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import { isDisplayedAndChecked } from "Store/akaAdvice/interfaces/getters";
import { getAdviceValueOrMinPayout } from "./utils";

export const mapToCrtiticalIllnessFormValues = (
  isAdvisor: boolean,
  need: CoverageNeed,
): Partial<AkaCriticalIllnessAdviceFormValues> => {
  const akaCriticalIllnessCoverageAmountCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.AKA_CRITICAL_ILLNESS,
  );
  const criticalIllnessInsuredSumCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.CRITICAL_ILLNESS,
  );

  return {
    [AkaAdviceCheckboxes.CRITICAL_ILLNESS_CHECKBOX]:
      akaCriticalIllnessCoverageAmountCheckbox ||
      criticalIllnessInsuredSumCheckbox,

    akaCriticalIllnessCoverageAmountCheckbox,
    akaCriticalIllnessCoverageAmountGLevel: String(
      getAdviceValueOrMinPayout(
        need,
        ProductCoverageName.AKA_CRITICAL_ILLNESS,
        isAdvisor,
      ),
    ),

    akaCriticalIllnessCoverageAmountCoInsuredCheckbox: false,
    akaCriticalIllnessCoverageAmountCoInsuredGLevel: String(
      AKA_CRITICAL_ILLNESS_DEFAULT_G_VALUE,
    ),

    criticalIllnessInsuredSumCheckbox,
    criticalIllnessInsuredSumSlider: getAdviceValueOrMinPayout(
      need,
      ProductCoverageName.CRITICAL_ILLNESS,
      isAdvisor,
    ),
    criticalIllnessAdviceComment: undefined,
  };
};
